import { getLens } from '@upright/ui/common/upright/core/impact-lenses';
import { useCarouselContext } from '../../context';

export function TopRightActions() {
  const context = useCarouselContext();
  const lens = getLens(context.lensType);
  if (!lens.TopRightActions) return <></>;
  return <lens.TopRightActions />;
}
